import { Component, OnDestroy, OnInit,ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import {MatMenuTrigger} from "@angular/material/menu"
import { DashboardNotificationService } from "./dashboard-notification.service"

@Component({
  selector: 'dashboard-notification',
  templateUrl: './dashboard-notification.component.html',
  styleUrls: ['./dashboard-notification.component.scss']
})
export class DashboardNotificationComponent implements OnInit, OnDestroy {

  notificationList: any[];

  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
 

  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {Renderer2} _renderer
   * @param {CookieService} _cookieService
   * @param {FuseMatchMediaService} _fuseMatchMediaService
   * @param {FuseNavigationService} _fuseNavigationService
   * @param {ObservableMedia} _observableMedia
   */
  constructor(
    public _dashboardNotificationService: DashboardNotificationService
  ) {

    // Set the defaults
    this.notificationList = [];

    // Set the private defaults
    this._unsubscribeAll = new Subject();
    
    
  }

  ngAfterViewInit() {
    if (this.trigger !== undefined) {
      this.trigger.onMenuClose
        .subscribe(e => {
          this.notificationList = [];
        });
    }
  }

  markNotificationAsRead() {
    this._dashboardNotificationService.isNotificationActive = false;
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this._dashboardNotificationService.notifications.subscribe(res => {
      var response = res.length;
      if (response === undefined)
        this.notificationList.push(res[0]);
    });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

}
